import React, { useEffect } from 'react'
import { CssBaseline} from "@mui/material";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { GenGet } from  './state/api';
import SiteRoot from "./Site";
import AdminRoot from "./Admin";
import RequiredAuth from './Loja/components/RequireAuth';
import Login from './Admin/scenes/auth/Login';

function App() {
  const token = localStorage.getItem('token');

  async function checkAuth() {
    try {
      await GenGet("/employee/check");
        
      return;
    
      } catch (err) {
      localStorage.removeItem('token');
      window.location.reload()
      console.log(`Erro : ${err}`);
    }
  }

  useEffect(() => {
    if(token){
      checkAuth();
    }
    
  }, [token]);

  return (
    <div className="App">

        <BrowserRouter>
            <CssBaseline />
            <Routes>
              <Route path="/*" element={<SiteRoot />} /> 
              <Route path="/login" element={<Login/>} />  
              <Route element={<RequiredAuth/>}>
                <Route path="/sistema/*" element={<AdminRoot/>} />
              </Route> 
            </Routes>
           
        </BrowserRouter>

    </div>
  );
}

export default App;